module.exports = __webpack_public_path__ + "static/media/monkey-eating.90262841.png";